"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorWidgetDataSchema = exports.RegionRecentSelectItemTypeSchema = void 0;
var zod_1 = require("zod");
exports.RegionRecentSelectItemTypeSchema = zod_1.z.object({
    /** 이동할 링크(앱/웹) */
    action: zod_1.z.object({
        app: zod_1.z.string().nullish(),
        web: zod_1.z.string().nullish(),
    }),
    logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    /** 지역 1depth 비즈니스 정책에 따라 2depth의 값이 "전체"에 해당할 경우, null 응답 */
    parentRegion: zod_1.z
        .object({
        code: zod_1.z.string(),
        title: zod_1.z.string(),
    })
        .nullish(),
    /** 지역 2depth - 클라이언트에서 요청값으로 받는 leaf(상세) depth의 지역명 */
    region: zod_1.z.object({
        code: zod_1.z.string(),
        title: zod_1.z.string(),
    }),
});
exports.RegionSelectorWidgetDataSchema = zod_1.z.object({
    logMeta: zod_1.z.record(zod_1.z.unknown()),
    regionRecentSelected: zod_1.z
        .object({
        header: zod_1.z.object({
            title: zod_1.z.string().nullish(),
        }),
        /** 최근 선택 지역 */
        items: zod_1.z.array(exports.RegionRecentSelectItemTypeSchema),
    })
        .nullish(),
    regionDiscovery: zod_1.z.object({
        header: zod_1.z.object({
            /** 위젯 타이틀 아이콘 추후 2개 이상의 아이콘이 필요시 titleIcon으로 변경하고 prefix, postfix로 구분하여 return할 것 */
            icon: zod_1.z.string().nullish(),
            /** 더보기 */
            more: zod_1.z.undefined().nullish(),
            /** 위젯 서브 타이틀 */
            subTitle: zod_1.z.string().nullish(),
            /** 위젯 타이틀 */
            title: zod_1.z.string(),
        }),
        items: zod_1.z.array(zod_1.z.object({
            /** 이동할 링크(앱/웹) */
            action: zod_1.z
                .object({
                app: zod_1.z.string().nullish(),
                web: zod_1.z.string().nullish(),
            })
                .nullish(),
            /** 화면에 보여지는 icon */
            icon: zod_1.z.string().nullish(),
            logMeta: zod_1.z.record(zod_1.z.unknown()),
            /** 화면에 보여지는 명칭 */
            title: zod_1.z.string(),
            /** BUTTON_AROUND - 내주변 버튼, BUTTON_REGION - 지역 선택 버튼, BUTTON_SUBWAY - 역주변 버튼 */
            type: zod_1.z.enum(['BUTTON_REGION', 'BUTTON_SUBWAY', 'BUTTON_AROUND']),
        })),
    }),
});
